/* eslint-disable max-classes-per-file */
import { __decorate, __metadata } from "tslib";
import { IsUUID } from 'class-validator';
/**
 * Requests details of a user in the context of a court system
 */
export class UserGetForCourtSystemParams {
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], UserGetForCourtSystemParams.prototype, "userId", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], UserGetForCourtSystemParams.prototype, "courtSystemId", void 0);
/**
 * Details of a user, along with their groups (if any) in a given court system
 */
export class UserGetForCourtSystemResult {
    /**
     * @param id Identifies the user
     * @param email User's registered email address
     * @param givenName Given name of the user
     * @param familyName Family name of the user
     * @param groups Groups the user has been allocated against the filtered court system
     * @param signOnMethods the sign-on methods for this user (e.g. FTR, Microsoft, etc)
     * @param isMfaEnabled indicates if MFA is enabled for the FTR Method
     */
    constructor(id, email, givenName, familyName, groups, signOnMethods, isMfaEnabled) {
        this.id = id;
        this.email = email;
        this.givenName = givenName;
        this.familyName = familyName;
        this.groups = groups;
        this.signOnMethods = signOnMethods;
        this.isMfaEnabled = isMfaEnabled;
    }
}
